(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/eventService"] = factory();
	else
		root["@makolab/library-react/dist/eventService"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 85);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/utils");

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = require("lodash/has");

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = require("lodash/isFunction");

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = require("lodash/isEmpty");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/console");

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

module.exports = require("lodash/isString");

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROP_TYPE_EVENT_SERVICE", function() { return PROP_TYPE_EVENT_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventService", function() { return EventService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eventemitter3__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eventemitter3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_eventemitter3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isString__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_union__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_union___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_union__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_values__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__console__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__console___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__console__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__utils__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var PROP_TYPE_EVENT_SERVICE=__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({registerEventName:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,getEvent:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,eventNames:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,addListener:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,on:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,once:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,removeListener:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,off:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,emit:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,removeAllListeners:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired});var EventService=function EventService(){var _this=this;_classCallCheck(this,EventService);this._EVENTS={};this._EE=new __WEBPACK_IMPORTED_MODULE_0_eventemitter3___default.a();this.registerEventName=function(eventName){if(__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(_this._EVENTS,eventName)){return _this;}var name=eventName+'-'+Object(__WEBPACK_IMPORTED_MODULE_9__utils__["randomId"])();_this._EVENTS[eventName]=name;__WEBPACK_IMPORTED_MODULE_8__console___default.a.debug(['Event "'+name+'" has been registered.','Available events: \n- '+_this.eventNames().join('\n- ')].join('\n'));return _this;};this.getEvent=function(eventName){return _this._EVENTS[eventName];};this.eventNames=function(){return __WEBPACK_IMPORTED_MODULE_5_lodash_union___default()(_this._EE.eventNames(),__WEBPACK_IMPORTED_MODULE_6_lodash_values___default()(_this._EVENTS));};this.addListener=function(){return _this.on.apply(_this,arguments);};this.on=function(eventName,callback,context){if(!__WEBPACK_IMPORTED_MODULE_2_lodash_isString___default()(eventName)){__WEBPACK_IMPORTED_MODULE_8__console___default.a.error(new TypeError('Expected eventName "'+eventName+'" to be string, received '+(typeof eventName==='undefined'?'undefined':_typeof(eventName))+' instead.'));}else if(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(eventName)){__WEBPACK_IMPORTED_MODULE_8__console___default.a.error(new TypeError('Expected eventName "'+eventName+'" to not be an empty string.'));}else if(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(callback)){_this._EE.on(eventName,callback,{messageService:_this,context:context});}else{__WEBPACK_IMPORTED_MODULE_8__console___default.a.error(new TypeError('Expected callback to be a function, received '+(typeof callback==='undefined'?'undefined':_typeof(callback))+' instead..'));}return _this;};this.once=function(eventName,callback,context){if(!__WEBPACK_IMPORTED_MODULE_2_lodash_isString___default()(eventName)){__WEBPACK_IMPORTED_MODULE_8__console___default.a.error(new TypeError('Expected eventName "'+eventName+'" to be string, received '+(typeof eventName==='undefined'?'undefined':_typeof(eventName))+' instead.'));}else if(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(eventName)){__WEBPACK_IMPORTED_MODULE_8__console___default.a.error(new TypeError('Expected eventName "'+eventName+'" to not be an empty string.'));}else if(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(callback)){_this._EE.once(eventName,callback,{messageService:_this,context:context});}else{__WEBPACK_IMPORTED_MODULE_8__console___default.a.error(new TypeError('Expected callback to be a function, received '+(typeof callback==='undefined'?'undefined':_typeof(callback))+' instead..'));}return _this;};this.removeListener=function(){return _this.off.apply(_this,arguments);};this.off=function(eventName,callback,context){if(!__WEBPACK_IMPORTED_MODULE_2_lodash_isString___default()(eventName)){__WEBPACK_IMPORTED_MODULE_8__console___default.a.error(new TypeError('Expected eventName "'+eventName+'" to be string, received '+(typeof eventName==='undefined'?'undefined':_typeof(eventName))+' instead.'));}else if(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(eventName)){__WEBPACK_IMPORTED_MODULE_8__console___default.a.error(new TypeError('Expected eventName "'+eventName+'" to not be an empty string.'));}else if(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(callback)){_this._EE.removeListener(eventName,callback,{messageService:_this,context:context});}else{__WEBPACK_IMPORTED_MODULE_8__console___default.a.error(new TypeError('Expected callback to be a function, received '+(typeof callback==='undefined'?'undefined':_typeof(callback))+' instead..'));}return _this;};this.emit=function(eventName,data){__WEBPACK_IMPORTED_MODULE_8__console___default.a.info('Event "'+eventName+'" triggered.\n',data);if(!__WEBPACK_IMPORTED_MODULE_2_lodash_isString___default()(eventName)){__WEBPACK_IMPORTED_MODULE_8__console___default.a.error(new TypeError('Expected eventName "'+eventName+'" to be string, received '+(typeof eventName==='undefined'?'undefined':_typeof(eventName))+' instead.'));}else if(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(eventName)){__WEBPACK_IMPORTED_MODULE_8__console___default.a.error(new TypeError('Expected eventName "'+eventName+'" to not be an empty string.'));}else{_this._EE.emit(eventName,data);}return _this;};this.removeAllListeners=function(eventName){_this._EE.removeAllListeners(eventName);return _this;};}/**
   * @type {Object}
   * @private
   *//**
   * @type {EventEmitter3 | EventEmitter3<string | symbol>}
   * @private
   */;/* harmony default export */ __webpack_exports__["default"] = (new EventService());

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

module.exports = require("eventemitter3");

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

module.exports = require("lodash/union");

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

module.exports = require("lodash/values");

/***/ })

/******/ });
});
//# sourceMappingURL=eventService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/eventService.js
// module id = 658
// module chunks = 6